
<div class="dashboard-content-sec">
    <div class="card mb-0">
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <a data-toggle="collapse" id="authkey-expand" 
                    style="width:180px" class="p-2 fa fa-expand-alt" 
                    href="#authKeyTable" > 
                    <!-- (click)="swapIcon($event)"> -->
                        {{this.total}} SSO Auth Keys</a>
            </div>
 
            <div style='width: 120px' class="d-inline-block">
                <a data-toggle="collapse" href="#newAuthKey" 
                    class="fa fa-user-circle btn btn-default ">
                    Add SSO Auth Key
                </a>                        
            </div>  

            <div id="newAuthKey" class="collapse mt-3">
                <app-authkey [authkey_id]="0" 
                    [partner_id]="partner_id" (submit_return)="collapseAuthKey()"> 
                </app-authkey>
            </div>                   
            
        </div>

        <div id="authKeyTable" class="table-responsive collapse">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <!-- <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i>  -->
                            {{header.text}}
                        </th>
                      <th>Delete</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let ak of authKeysList">
                        <tr>
                            <td>
                                <a data-toggle="collapse" href="#authKeyEdit{{ak.ID}}">
                                    {{ak.Auth }}
                                </a>
                            </td>

                            <td>
                                <a data-toggle="collapse" href="#authKeyEdit{{ak.ID}}">
                                    {{ak.Iss }} 
                                </a>
                            </td>

                            <td>
                                <a data-toggle="collapse" href="#authKeyEdit{{ak.ID}}">
                                    {{ak.Created_at | date:'MMM dd/yy hh:mma'}} 
                                </a>
                            </td>

                            <td>
                                <div class="d-inline-block">
                                    <a title="Delete" class="btn fa fa-times" (click)="deleteAuthKey(ak.ID)"> </a>
                                </div>
                            </td>
                        </tr>
                        <tr class="h-0">
                            <td colspan="6" class="p-0 m-0">
                                <div id="authKeyEdit{{ak.ID}}" class="collapse user_edit">
                                    <app-authkey [authkey_id]="ak.ID" [partner_id]="partner_id"
                                       (submit_return)="collapseAuthKey()"></app-authkey>
                                </div>
                            </td>
                        </tr>
                        <tr class="h-0"></tr>                    

                    </ng-container>
                </tbody>

                <ng-container *ngIf="authKeysList?.length == 0">
                  <tr><td colspan="5">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
